<template>
    <div class="zhongjian1">
        <div class="middle1_box">
            <div class="conten">
                <div class="text1">新增资源{{ total }}</div>
                <h1 class="text2">{{text1}}</h1>
                <h1 class="text2">{{text2}}<span class="text5">{{title}}</span></h1>
                <div class="text3">{{text3}}</div>
                <dr></dr>
                <div class="text4">{{text4}}</div>
            </div>
            <div class="webicon">
                <div class="grid1 gridcon">
                    <div :class="i.className" v-for="i,index in list1" :key="index"><img :src="i.url" alt=""></div>
                </div>
                <div class="grid2 gridcon">
                    <div :class="i.className" v-for="i,index in list2" :key="index"><img :src="i.url" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref,computed} from 'vue'
import { useStore} from 'vuex'
import { Get8logo,GetItemtotal } from '@/api';

const store = useStore()

const title = computed(()=>{return store.state.app.sysinfo.title})
const text1 = computed(()=>{return store.state.app.sysinfo.text1})
const text2 = computed(()=>{return store.state.app.sysinfo.text2})
const text3 = computed(()=>{return store.state.app.sysinfo.text3})
const text4 = computed(()=>{return store.state.app.sysinfo.text4})


const list1 = ref()
const list2 = ref()
const total = ref()

onMounted(()=>{
    Get8logo().then(res=>{
        list1.value = res.slice(0,4)
        list2.value = res.slice(4,8)
        list1.value.forEach(i=>{
            i.url = process.env.VUE_APP_PIC_URL + i.url
        })
        list2.value.forEach(i=>{
            i.url = process.env.VUE_APP_PIC_URL + i.url
        })
    }).catch()
    GetItemtotal().then(res=>{
        total.value = res.total
    }).catch()
})


</script>

<style lang="scss" scoped>
.zhongjian1{
    background: var(--bac-ground);
    width: 100vw;
    height: 40rem;
    position: relative;
    overflow: hidden;
    margin-top: 5rem;
    z-index: 2;
    .middle1_box{
        .conten{
            width: 100vw;
            position: absolute;
            top: 5rem;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .text1{
                padding: .4rem 1.2rem;
                // border: 1px solid #d9c8c8;
                border-radius: 2rem;
                margin: 1rem;
                font-size: .8rem;
                color:var(--middle-conten-text1-color);
                background: var(--middle-conten-text1-bac);
            }
            .text2{
                font-size: 5rem;
                font-weight: 700;
                margin: .8rem;
                color:var(--text-color)
            }
            .text3{
                margin-top: 2rem;
                font-size: 1.25rem;
                color: #848282;
            }
            .text4{
                margin-top: .5rem;
                font-size: 1.25rem;
                color: #848282;
            }
            .text5{
                text-shadow:var(--conten-text1-shadow);
            }
        }
        .webicon{
            display: flex;
            justify-content:space-between;
            position: absolute;
            bottom: -2.5rem;
            width: 100vw;
            .gridcon{
                grid-template-columns: repeat(3, minmax(0, 1fr));
                width: 25rem;
                height: 25rem;
                display: grid;
                gap: 10px;
                aspect-ratio: 1 / 1;
                >div{
                    width: fit-content;
                    overflow: hidden;
                    >img{
                        width: 7.3rem;
                        animation: back-imagea .5s .35s ease-in-out forwards;
                        opacity: 0;
                        border-radius: 40px;
                    }
                }
                .grid1-box1{
                    grid-column: span 3 / span 3;
                }
                .grid1-box2{
                    // grid-column-start: 2;
                    grid-column: span 2 / span 2;
                    grid-column-start: 2;
                }
                .grid1-box3{
                    grid-column: span 2 / span 2;
                }
                .grid1-box5{
                    grid-column-start: 3;
                }
            }
            .grid1{
                margin-left: 3rem;
            }
            .grid2{
                margin-right: 3rem;
            }
        }
    }
}
</style>